import styles from '../styles/Archives.module.css';

const SubTitle = ({text}) => {
    return <div className={styles.subtitle}>{text}</div>
};

export default SubTitle;